(function () {
  'use strict';

  /* global _ */
  class EditarUsuarioCtrl {
    constructor(usuario, uoArvore, PerfisPublic, $uibModalInstance, UsuariosService, Flash, PerfilIntegracao,
      PerfilAdminVeltec, Authenticator, PaisService, IdiomasEnum, MeasurementSystemEnum, RolesEnum, AlertMessage, $translate, UsuariosMessageMap, SHARED_EMAIL_THIRD_PARTY, isNaOu,
      FeaturehubJsSdk, FeatureHubConfigKeys) {
      this.isNaOu = isNaOu;
      this.idiomasEnum = IdiomasEnum;
      this.measurementSystemEnum = MeasurementSystemEnum;
      this.isMeasurementSystemEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.MEASUREMENT_SYSTEM);
      this.rolesEnum = RolesEnum;
      this.usuario = _.cloneDeep(usuario);
      this.perfisService = PerfisPublic;
      this.modalInstance = $uibModalInstance;
      this.usuariosService = UsuariosService;
      this.uoArvore = uoArvore;
      this.alertMessage = AlertMessage;
      this.paisService = PaisService;
      this.perfilSelecionado = this.usuario.perfil;
      this.idiomaSelecionado = this.idiomasEnum.getIdiomaByKey(this.usuario.idioma) || this.idiomasEnum.getIdiomaByKey('PT_BR');
      this.usuario.measurementSystem = this.usuario.measurementSystem ||
        this.measurementSystemEnum.getDefaultKeyForLanguage(this.idiomaSelecionado.key);
      this.isResponsavelPassiveis = this.getIsReponsavelPassiveis(this.usuario.isResponsavelPassiveis);
      this.acessoTrocaUo = this.getAcessoTrocaUo(this.usuario.acessoTrocaUo);
      this.uoSelecionada = uoArvore.filter(uo => uo.id === this.usuario.uoId)[0];
      this.flash = Flash;
      this.perfilIntegracao = PerfilIntegracao;
      this.perfilAdminVeltec = PerfilAdminVeltec;
      this.limit = 10;
      this.paises = [];
      this.mapBandeiras = new Map();
      this.minCaracteres = 3;
      this.maxCaracteres = 50;
      // Para usuário com telefone cadastrado vai ser obrigatório o campo de telefone
      this.telefoneCadastrado = Boolean(this.usuario.telefone);
      this.keycloakUser = null;
      this.canChange2fa = false;
      this.translate = $translate;
      this.usuariosMessageMap = UsuariosMessageMap;
      this.EMAIL_THIRD_PARTY = SHARED_EMAIL_THIRD_PARTY;
      Authenticator.getUser().then(user => {
        this.user = user;
        this.carregarPaises();
        this.carregarPerfis();
        this.carregarKeycloakUser();
        const emailMain = this.user.login ? this.user.login.split('@') : [];
        this.domainEditAccessOU = emailMain.length > 1 ? emailMain[1] === 'trimble.com' || emailMain[1] === 'platformscience.com' : false;
      });
    }

    loadMore() {
      this.limit += 10;
    }

    carregarPaises() {
      const idioma = (this.user && this.user.idioma) || 'PT_BR';
      this.paisService.getList({idioma}).then(paises => {
        this.paises = paises.plain();
        this.paises.forEach(pais => {
          if (this.usuario.pais && this.usuario.pais.code === pais.code) {
            this.usuario.pais = pais;
          }

          if (this.usuario.paisTelefone && this.usuario.paisTelefone.code === pais.code) {
            this.usuario.paisTelefone = pais;
          }

          this.mapBandeiras.set(pais.code, this.getLinkImgBandeira(pais.code));
        });
      });
    }

    carregarPerfis() {
      this.perfisService.getList().then(perfis => {
        this.perfis = perfis.plain()
          .filter(p => p.nome !== 'VDrivers')
          .filter(p => p.id !== this.perfilIntegracao || this.user.perfil.id === this.perfilAdminVeltec)
          .map(p => {
            if (this.rolesEnum.getDescricaoByDescricaoDB(p.nome)) {
              p.nome = this.translate.instant(this.rolesEnum.getDescricaoByDescricaoDB(p.nome));
            }
            return p;
          });
      });
    }

    carregarKeycloakUser() {
      this.usuariosService
        .one(this.usuario.id)
        .one('keycloak')
        .get()
        .then(keycloakUser => {
          this.keycloakUser = keycloakUser;
          this.canChange2fa = !!keycloakUser.id;
          this.enable2fa = !!keycloakUser.totp || (keycloakUser.requiredActions ? keycloakUser.requiredActions.includes('CONFIGURE_TOTP') : false);
        });
    }

    change2fa() {
      this.usuariosService
      .one(this.usuario.id)
      .one('otp')
      .one(this.enable2fa)
      .customPUT()
      .then(() => {
        this.alertMessage.create({
          type: 'success',
          message: 'Two Factor Authentication atualizado com sucesso!',
          appendTo: '.alerta-2fa-aqui'
        });
      }).catch(() => {
        this.enable2fa = !this.enable2fa;
        this.alertMessage.create({
          type: 'error',
          message: 'Ocorreu um erro ao atualizar o Two Factor Authentication',
          appendTo: '.alerta-2fa-aqui'
        });
      });
    }

    getLinkImgBandeira(code) {
      return `https://vfleets-imagens.s3-sa-east-1.amazonaws.com/paises/${code.toLowerCase()}.png`;
    }

    getIsReponsavelPassiveis(isResponsavel) {
      if (angular.isDefined(isResponsavel) && isResponsavel !== null) {
        return String(isResponsavel);
      }
      return null;
    }

    getAcessoTrocaUo(canChangeOU) {
      if (angular.isDefined(canChangeOU) && canChangeOU !== null) {
        return String(canChangeOU);
      }
      return null;
    }

    errorValidarTelefone(form) {
      if (this.telefoneCadastrado) {
        return this.dddError(form) || this.ddiError(form) ||
                this.dddDdiError(form) || this.telefoneError(form) ||
                this.telefoneVazio(form);
      }
      return this.dddError(form) || this.ddiError(form) || this.dddDdiError(form || this.telefoneError(form));
    }

    labelError(form) {
      return this.comecouEdicaoTelefone(form) &&
             (this.dddError(form) ||
             this.ddiError(form) ||
             this.telefoneError(form) ||
             this.dddDdiError(form));
    }

    dddError(form) {
      return this.dddVazio(form) &&
            (!this.ddiVazio(form) &&
            !this.numeroVazio(form) ||
            this.numeroVazio(form) &&
            !this.ddiVazio(form));
    }

    telefoneError(form) {
      return this.numeroVazio(form) &&
            (!this.ddiVazio(form) ||
            !this.dddVazio(form));
    }

    ddiError(form) {
      return this.ddiVazio(form) &&
            (!this.dddVazio(form) &&
            !this.numeroVazio(form) ||
            !this.dddVazio(form) &&
            this.numeroVazio(form));
    }

    dddDdiError(form) {
      return this.dddVazio(form) &&
             this.ddiVazio(form) &&
             !this.numeroVazio(form);
    }

    telefoneVazio(form) {
      return (form.ddd.$viewValue === '' || !form.ddd.$viewValue) &&
        (form.paisTelefone.$viewValue === '' || !form.paisTelefone.$viewValue) &&
        (form.telefone.$viewValue === '' || !form.telefone.$viewValue);
    }

    dddVazio(form) {
      return form.ddd.$viewValue === '' || !form.ddd.$viewValue;
    }

    ddiVazio(form) {
      return form.paisTelefone.$viewValue === '' || !form.paisTelefone.$viewValue;
    }

    numeroVazio(form) {
      return form.telefone.$viewValue === '' || !form.telefone.$viewValue;
    }

    comecouEdicaoTelefone(form) {
      return form.telefone || form.ddd || form.paisTelefone;
    }

    loginIsThirdParty(email) {
      const emailParts = email ? email.split('@') : [];
      if (emailParts.length < 2) {
        return false;
      }
      return this.EMAIL_THIRD_PARTY.includes(emailParts[1]) && this.perfilAdminVeltec === this.user.perfil.id;
    }

    responsavelError(form) {
      if (form.isResponsavelPassiveis.$dirty) {
        return form.isResponsavelPassiveis.$viewValue === '' || !form.isResponsavelPassiveis.$viewValue;
      }
      return false;
    }

    salvar() {
      const mustKillSession = this.usuario.uo.id !== this.uoSelecionada.id;
      this.usuario.uo = this.uoSelecionada;
      this.usuario.perfil = this.perfilSelecionado;
      this.usuario.idioma = this.idiomaSelecionado.key;
      if (!this.isMeasurementSystemEnabled) {
        this.usuario.measurementSystem = this.measurementSystemEnum.getDefaultKeyForLanguage(this.idiomaSelecionado.key);
      }
      this.usuario.isResponsavelPassiveis = this.isResponsavelPassiveis;
      if (this.domainEditAccessOU && this.loginIsThirdParty(this.usuario.login)) {
        this.usuario.acessoTrocaUo = this.acessoTrocaUo;
      } else {
        delete this.usuario.acessoTrocaUo;
      }
      this.usuariosService.one(this.usuario.id).customPUT(this.usuario, undefined, {mustKillSession}).then(
        () => {
          this.modalInstance.close();
          this.alertMessage.create({
            type: 'success',
            message: this.translate.instant('core-permissoes.organizacao.usuarios.popup.registrationEditedSuccessfully'),
            appendTo: '.alerta-aqui'
          });
        },
        data => {
          const messageKey = this.usuariosMessageMap[data.data.message];
          let message = messageKey ? this.translate.instant('core-permissoes.organizacao.usuarios.popup.' + messageKey) : data.data.message;
          this.flash.create('error', message);
        }
      );
    }

    novaSenha() {
      this.usuariosService.one(this.usuario.id).customPOST(null, 'nova-senha').then(
        () => this.flash.create('success', this.translate.instant('core-permissoes.organizacao.usuarios.popup.emailSentSuccessfully')),
        () => this.flash.create('error', this.translate.instant('core-permissoes.organizacao.usuarios.popup.errorSendingEmail'))
      );
    }

    cancel() {
      this.modalInstance.dismiss('cancel');
    }

    ok(form) {
      if (form.$valid && !this.errorValidarTelefone(form)) {
        this.salvar();
      } else {
        form.uo.$setDirty();
        form.login.$setDirty();
        form.nome.$setDirty();
        if (this.isNaOu) {
          form.lastName.$setDirty();
        }
        form.perfil.$setDirty();
        form.pais.$setDirty();
        form.isResponsavelPassiveis.$setDirty();
      }
    }
  }

  angular
    .module('usuarios')
    .controller('EditarUsuarioCtrl', EditarUsuarioCtrl);
}());
